import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import i18n from './modules/i18n'
import errorLog from './modules/errorLog'
// import permission from './modules/permission'
import tagsView from './modules/tagsView'
import user from './modules/user'
import getters from './getters'
import addRouters from "./modules/generateRoutes"
import supplierRegister from './modules/supplierRegister'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    i18n,
    errorLog,
    // permission,
    tagsView,
    user,
    addRouters,
    supplierRegister
  },
  getters
})

export default store
